import { getFrameDimensions, Orientation } from '@marvelapp/core';
import { getFrame, getOrientation } from './project';
export function getDimensions(state) {
    var dimensions = getFrameDimensions(getFrame(state));
    var orientation = getOrientation(state);
    if (orientation === Orientation.Landscape) {
        dimensions = rotate(dimensions);
    }
    return dimensions;
}
function rotate(_a) {
    var width = _a.width, height = _a.height, padding = _a.padding, borderRadius = _a.borderRadius;
    // Rotate right
    return {
        width: height,
        height: width,
        padding: [padding[3], padding[0], padding[1], padding[2]],
        borderRadius: borderRadius,
    };
}
